<template>
  <div id="view-selector">
    <div class="option">
      <button
        :class="{selected: value === 'climate'}"
        @click="$emit('input', 'climate')"
      >
        Climatología
      </button>
    </div>
    <div class="option">
      <button
        :class="{selected: value === 'region'}"
        @click="$emit('input', 'region')"
      >
        Contexto regional
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ViewSelector',

  props: {
    value: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

#view-selector {
    grid-area: view-selector;
    border-radius: $border-radius;
    overflow: hidden;
    display: grid;
    grid-template-columns: 50% 50%;

    .option {
        justify-self: stretch;

        button {
            width: 100%;
            height: 100%;
            border: 0;
            background-color: $color-clear;

            &.selected {
                background-color: $color-highlight;
                color: $color-highlight-contrast;
            }
        }
    }
}
</style>
